import { Professional } from "../models/Professional";
import { User } from "../models/User";
import api from "./api"; // the custom Axios instance

const PATH = "/api/v1/users";

export const UserService = {
  async createUser(
    userData: Omit<User, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const res = await api.post(PATH, userData);
    return res.data?.data?._id ?? ""; // Return the new user's ID or empty string if not created
  },

  async getUser(userId: string): Promise<User | null> {
    try {
      const res = await api.get(`${PATH}/${userId}`);
      return res.data?.data ?? null;
    } catch (err) {
      console.error("Error fetching user:", err);
      return null;
    }
  },

  async getUsers(): Promise<User[]> {
    try {
      const res = await api.get(PATH);
      return res.data?.data ?? [];
    } catch (err) {
      console.error("Error fetching users list:", err);
      return [];
    }
  },

  async updateUser(
    userId: string,
    file: globalThis.File | null,
    updatedData: Partial<Omit<User, "_id" | "createdAt" | "updatedAt">>,
  ): Promise<void> {
    const formData = new FormData();
    if (file) formData.append("file", file);

    formData.append("firstName", updatedData.firstName!);
    formData.append("lastName", updatedData.lastName!);
    if (updatedData.email) formData.append("email", updatedData.email);
    if (updatedData.phoneNumber)
      formData.append("phoneNumber", updatedData.phoneNumber);
    if (updatedData.type) formData.append("type", updatedData.type);
    await api.patch(`${PATH}/${userId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteUser(userId: string): Promise<void> {
    try {
      await api.delete(`${PATH}/${userId}`);
    } catch (err) {
      console.error("Error deleting user:", err);
      throw err; // Rethrow to handle in the calling component
    }
  },

  async createProfessional(
    userId: string,
    file: globalThis.File | null,
    updatedData: Partial<Omit<Professional, "_id" | "createdAt" | "updatedAt">>,
  ): Promise<void> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    formData.append("firstName", updatedData.firstName!);
    formData.append("lastName", updatedData.lastName!);
    if (updatedData.email) formData.append("email", updatedData.email);
    if (updatedData.phoneNumber)
      formData.append("phoneNumber", updatedData.phoneNumber);
    await api.post(`${PATH}/${userId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
